class HighlightUtils {
  static highlight (haystack, needle) {
    // filter items
    if (needle === '') {
      return haystack
    }

    const cleanNeedle = needle.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')

    const reg = new RegExp(`(${cleanNeedle})+`, 'gi')
    const highlighted = haystack.replace(reg, match => `<b>${match}</b>`)
    return highlighted
  }
}

export default HighlightUtils
